module.exports = __webpack_public_path__ + "static/media/chat-group-banner.8c9d045d.svg";